export default __webpack_public_path__ + "static/media/no-image-panoramic.91b6e7e4.png";